export default async function getCondominioData() {
    try {
        const userSession = JSON.parse(sessionStorage.getItem('user'));

        if (!userSession || !userSession.condominio || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { condominio, token } = userSession;
        console.log("Condominios: ", condominio);

        // Ajuste a URL conforme necessário.
        // Aqui assumimos que existe uma rota GET /condominio/:nome no servidor.
        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/condominio/${encodeURIComponent(condominio)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erro ao buscar dados do condomínio: ${response.statusText}`);
        }

        const data = await response.json();

        // Garante que `data.condominio` exista conforme o retorno esperado da API
        if (!data || !data.condominio) {
            throw new Error("Resposta inválida da API ou condomínio não encontrado.");
        }

        return data; // Retorna o objeto completo (data.condominio e qualquer outro campo)
    } catch (error) {
        console.error("Erro ao carregar dados do condomínio:", error.message);
        return { condominio: null }; // Retorna um objeto padrão em caso de erro
    }
}
